module.exports = __webpack_public_path__ + "static/media/report.2a6a8174.svg";